<template>
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold mb-4">Register</h1>
    <p class="text-lg text-gray-600">This page is coming soon.</p>
  </div>
</template>